/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

// Spatial routines
// For now there is a dependency on Google Maps API.

// Returns true if geom contains a point
function containsPoint(geom, lat, lon) {
	if(geom.type !== "POLYGON" && geom.type !== "MULTIPOLYGON") {
		throw new Error("Unsupported geometry type for geometry A: " + geom.type);
	}

	let point = new google.maps.LatLng(lat, lon);

	let polygons = (geom.type === "MULTIPOLYGON") ? geom.data : [geom.data];

	for(let encodedPaths of polygons) {
		let polygon = new google.maps.Polygon({
			paths: encodedPaths.map(google.maps.geometry.encoding.decodePath)
		});
		if(google.maps.geometry.poly.containsLocation(point, polygon)) {
			return true;
		}
	}

	return false;
}

function segmentsIntersect(
	x1, y1, x2, y2,
	x3, y3, x4, y4) {
	let s1 = (y1-y3) * (x4-x3) < (y4-y3) * (x1-x3);
	let s2 = (y2-y3) * (x4-x3) < (y4-y3) * (x2-x3);
	let s3 = (y3-y1) * (x2-x1) < (y2-y1) * (x3-x1);
	let s4 = (y4-y1) * (x2-x1) < (y2-y1) * (x4-x1);

	return (s1 != s2) && (s3 != s4);
}

export default {
	containsPoint,
	segmentsIntersect
};
